/* Native Shopify pack form: quantity multiplies complete packs, never loose items. */
(() => {
 function init(root) {
  if(root.dataset.packReady)return;root.dataset.packReady='true';
  const count=Number(root.dataset.count),gross=Number(root.dataset.gross),net=Number(root.dataset.net);
  const money=new Intl.NumberFormat('en-GB',{style:'currency',currency:root.dataset.currency||'GBP'});
  const input=root.querySelector('[data-pack-quantity]');
  function update(){
   const n=Number(input.value),valid=Number.isSafeInteger(n)&&n>=1;
   input.setCustomValidity(valid?'':'Please choose a whole number of packs, starting at 1.');
   if(!valid)return;
   root.querySelector('[data-pack-total]').textContent=`${n} ${n===1?'pack':'packs'} = ${n*count} ${root.dataset.unit}. This is not a single-item purchase.`;
   root.querySelector('[data-pack-subtotal]').textContent=money.format(gross*n/100);
   const ex=root.querySelector('[data-pack-net]');if(ex)ex.textContent=`${money.format(net*n/100)} excluding VAT`;
  }
  input.addEventListener('input',update);update();
  root.querySelectorAll('[data-pack-photo], [data-pack-video]').forEach(button=>button.addEventListener('click',()=>{
   const showVideo=button.hasAttribute('data-pack-video'),panel=root.querySelector('[data-pack-video-panel]'),photo=root.querySelector('[data-pack-hero-link]');
   photo.hidden=showVideo;
   if(panel){panel.hidden=!showVideo;if(!showVideo)panel.querySelector('video').pause();}
   root.querySelectorAll('[data-pack-photo], [data-pack-video]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   if(showVideo)return;
   const img=root.querySelector('.pp-pack-hero-image');img.removeAttribute('srcset');img.src=button.dataset.packPhoto;img.alt=button.dataset.packAlt;img.width=Number(button.dataset.width);img.height=Number(button.dataset.height);
   root.querySelector('[data-pack-hero-link]').href=button.dataset.packFull;
  }));
 }
 document.querySelectorAll('[data-pp-pack]').forEach(init);
 document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-pp-pack]').forEach(init));
})();
